export default __webpack_public_path__ + "static/media/ast-929551.e5d2467a.jpg";